<template>
  <b-card title="لیست نظرات ">


    <!-- search input -->
    <div class="custom-search  justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">جستوجو</label>
          <b-form-input
              v-model="searchTerm"
              type="text"
              class="d-inline-block"
              @change="getComments(currentPage)"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
        :select-options="{
        enabled: false,
        selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
        :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >


      <template
          slot="table-row"
          slot-scope="props"
      >

        <!-- Column: Name -->
        <span
            v-if="props.column.field === 'userFullName'"
            class="text-nowrap"
        >
          <b-avatar
              :src="props.row.userAvatar"
              class="mx-1"
          />
          <span class="text-nowrap">{{ props.row.userFullName }}</span>
        </span>

        <span
            v-else-if="props.column.field === 'comment'"
            class="text-nowrap"
        >
          <span class="text-nowrap">{{ props.row.data }}</span>
        </span>

        <span
            v-else-if="props.column.field === 'contentTitle'"
            class="text-nowrap"
        >
          <span class="text-nowrap">{{ props.row.contentTitle }}</span>
        </span>

        <!-- Column: Status -->
        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'status'">
          <b-badge :variant="status[props.row.approve]">
            {{ props.row.approve ? 'تایید شده' : 'تاید نشده' }}
          </b-badge>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">




            <b-button variant="info"
                      v-b-modal.modal-prevent-closing
                      @click="setId(props.row.id,props.row.approve,props.row.contentId) "
            >
                            <feather-icon
                                icon="CheckIcon"
                                class="mr-50"
                            />
                                        <span>اعتبار سنجی</span>

                        </b-button>







        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <template
          slot="pagination-bottom"
          slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
          نمایش  {{pageLength}} از
            </span>
            <b-form-select
                v-model="pageLength"
                :options="['30','50','70']"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
                @change="getComments(currentPage)"
            />
            <span class="text-nowrap"> از {{ props.total }} ورودی </span>
          </div>
          <div>
            <b-pagination
                :value="1"
                :total-rows="totalRecords"
                :per-page="pageLength"
                first-number
                last-number
                v-model="currentPage"
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value)=>getComments(currentPage)"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

    <b-modal
        id="modal-prevent-closing"
        ref="my-modal"
        title="اعتبار سنجی"
        ok-title="ثبت"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        @hidden="clearPriority"
        @ok="handleOk"
    >
      <b-card>

        <form
            ref="form"
            @submit.stop.prevent="handleSubmit"
        >

          <b-form-group
              label="اعتبار سنجی"
              label-for="name-input"
          >
            <b-form-radio
                v-model="approve"
                plain
                name="some-radios3"
                :value="true"
            >
              قبول
            </b-form-radio>
            <b-form-radio
                v-model="approve"
                plain
                name="some-radios3"
                :value="false"
            >
              رد
            </b-form-radio>
          </b-form-group>
        </form>

      </b-card>
    </b-modal>

  </b-card>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BAvatar,
  BCard,
  BFormRadio,
  VBModal,
  BModal,
  BBadge,
  BPagination,
  BFormGroup,
  BButton,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import store from '@/store/index'
import contentRepository from "@/modules/contents/services/contentRepository";
import {$themeConfig} from "@themeConfig";
import router from "@/router";
import Swal from 'sweetalert2'
import Ripple from "vue-ripple-directive";
import featurs from '@/navigation/vertical/featurs'


export default {
  name: "listContent",
  components: {
    VueGoodTable,
    BAvatar,
    BBadge,
    BButton,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BCard,
    BDropdownItem,
    BModal,
    BFormRadio
  },
  data() {
    return {
      contentId: undefined,
      commentId: undefined,
      secContentId: undefined,
      approve: undefined,
      pageLength: 30,
      currentPage: 1,
      totalRecords: 0,
      priortyRow: 0,
      pageCount: 0,
      dir: false,
      columns: [
        // {
        //   label: 'ردیف',
        //   field: 'row',
        // },
        {
          label: 'نام کاربر',
          field: 'userFullName',
        },
        {
          label: 'نام محتوا',
          field: 'contentTitle',
        },
        {
          label: 'متن نظر',
          field: 'comment',
        },
        {
          label: 'وضعیت',
          field: 'status',
        },
        {
          label: 'دستورات',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
      status:
        {
          true: 'light-success',
          false: 'light-danger',
        },
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        true: 'light-success',
        false: 'light-danger',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  async created() {
    this.contentId = router.currentRoute.params.id
    await this.getComments(1);
  }, methods: {
    async getComments(pageNo) {
      // let query = {
      //   pageNo: pageNo,
      //   pageSize: this.pageLength,
      //   key : this.searchTerm
      // };

      let query = this.contentId ?  ('/' + this.contentId) : '/all';
       query +=   `?pageNo=${pageNo}&pageSize=${this.pageLength}&app=false`;

      const {data} = await contentRepository.getComment(query);

      if (data.isSuccess) {
        this.rows = data.data.comments.map((p) => {
          return {
            userAvatar: p.userAvatar,
            userFullName: p.userFullName,
            approve: p.approve,
            contentId : p.contentId,
            data: p.data,
            contentTitle:p.contentTitle,
            id: p.id,
          }
        });

        this.totalRecords = data.data.totalRecordCount;
        console.log(this.rows)
      }
    },
    clearPriority(id) {
      console.log('showEditModal')
      this.commentId = undefined;
      this.approve = undefined;
    },
    async handleOk(bvModalEvt) {
      console.log('handleOk')

      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      await this.handleSubmit()
    },
    async handleSubmit() {
      console.log('handleSubmit')


      let query = '/' + this.secContentId;
      query +=   `?commentId=${this.commentId}&approve=${this.approve}`;


      const {data} = await contentRepository.approveComment(query)
      if (data.isSuccess) {
        await Swal.fire({
          confirmButtonText: 'ok',
          title: 'موفقیت',
          html: 'عملیات با موفقیت انجام شد',
          icon: 'success'
        })
        // await this.$router.replace('/contents/comments/' + this.contentId)
        await this.getComments(this.currentPage);
      } else {
        await Swal.fire('هشدار', data.message, 'warning')
      }

      await this.getCommentCount()


      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },
    async getCommentCount() {
      const { data } = await contentRepository.getCommentCount('');


      if (data.isSuccess){
        localStorage.setItem('commentsCount' , data.data);
        featurs[0].children[2].tag = data.data.toString()

      }

    },
    setId(id,approve , contentId) {
      this.commentId = id;
      this.approve =approve;
      this.secContentId = contentId;
    }
  },
  directives: {
    'b-modal': VBModal,
    Ripple: Ripple
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
